import {type UnreadCountDto} from '@onroadvantage/optix-safeandsound-openapi';
import {useQuery} from '@tanstack/react-query';

import {UNREAD_COUNT_QUERY_KEY} from './notificationQueryKeys';
import {notificationsApi} from '../../../../api';

const UNREAD_COUNT_REFETCH_INTERVAL_MS = 30_000;

export interface UseUnreadNotificationCountReturn {
  count: number;
  loading: boolean;
}

export const useUnreadNotificationCount =
  (): UseUnreadNotificationCountReturn => {
    const query = useQuery({
      queryKey: UNREAD_COUNT_QUERY_KEY,
      queryFn: async (): Promise<UnreadCountDto> => {
        return await notificationsApi.unreadCount();
      },
      refetchInterval: UNREAD_COUNT_REFETCH_INTERVAL_MS,
    });

    return {
      count: query.data?.count ?? 0,
      loading: query.isLoading,
    };
  };
